var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRuinWhite = function SvgRuinWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.5 11.192h3.333m0 0 1.917 2.423m-1.917-2.423 1.334-1.615H8.5l1.5-.808m-7.5 10.5L3.9 2.981h6.3l.495 2.468h3.585L15.306 1.5h5.049l.512 1.974H22l1.5 15.795zm9-3.23v-3.231c0-.893.672-1.616 1.5-1.616s1.5.723 1.5 1.616v3.23zM1 19.269h24V22.5H1z"
  })));
};
export default SvgRuinWhite;